import QuickSearchItem from '@/types/quick-search-item';

const exchangeMapper = (item: QuickSearchItem): string | undefined => {
  if (item.mic != null) {
    switch (item.mic) {
      case 'XNAS':
        return 'NSD';
      case 'XASE':
        return 'NYE';
      case 'NEOE':
        return 'NEO';
      case 'XTSE':
        return 'TSX';
      case 'XTSX':
        return 'TSXV';
      case 'XCNQ':
        return 'CSE';
      case 'XNYS':
        return 'NYE';
      case 'ARCX':
        return 'NYE';
      case 'PINX':
        return 'PINX';
      case 'OOTC':
        return 'OOTC';
    }
  }

  return item.exchange;
};

export default exchangeMapper;
